export function createTranscriptStore(config) {
    const { pingKey, clearedEvent } = config;
    let transcript = null;
    let serverAnalysis = null;
    function setTranscript(newTranscript) {
        transcript = newTranscript;
        serverAnalysis = null;
    }
    function getTranscript() {
        return transcript;
    }
    function setServerAnalysis(newAnalysis) {
        serverAnalysis = newAnalysis;
    }
    function getAnalysis() {
        return serverAnalysis;
    }
    function clearCurrent() {
        transcript = null;
        serverAnalysis = null;
        if (typeof window === "undefined")
            return;
        try {
            window.dispatchEvent(new CustomEvent(clearedEvent));
            localStorage.setItem(pingKey, String(Date.now()));
        }
        catch {
            // ignore storage/event errors
        }
    }
    return {
        CURRENT_PING_KEY: pingKey,
        CURRENT_CLEARED_EVT: clearedEvent,
        setTranscript,
        getTranscript,
        setServerAnalysis,
        getAnalysis,
        clearCurrent,
    };
}
